import { type IAggregation, type IAggregationResponse } from '@inpart-io/devtools-iap';
import { type MutationTree } from 'vuex';

import { type IAggregationByStatus, type IAmendmentState } from './types';

export const RECEIVE_AMENDMENT_STATUS_AGGREGATION_BY_AGREEMENT = 'RECEIVE_AMENDMENT_STATUS_AGGREGATION_BY_AGREEMENT';

function getStatusAggregation(aggregation: IAggregation): IAggregationByStatus {
    const statusAggregation: IAggregationByStatus = { byStatus: {}, totalCount: 0 };

    for (const statusGroup of aggregation.groups) {
        const statusKey = statusGroup.keyAsString.toUpperCase();
        statusAggregation.byStatus[statusKey] = statusGroup.objCount;
    }
    return statusAggregation;
}

export const mutations: MutationTree<IAmendmentState> = {
    [RECEIVE_AMENDMENT_STATUS_AGGREGATION_BY_AGREEMENT](
        _state,
        { aggregationResult, agreements }: { aggregationResult?: IAggregationResponse; agreements?: number[] }
    ) {
        if (aggregationResult !== undefined) {
            // Set default initial state
            for (const agreementId of agreements) {
                _state.aggregationByStatus[agreementId] = Object.assign({}, _state.aggregationByStatus[agreementId], { byStatus: {}, totalCount: 0 });
            }

            if (aggregationResult?.results?.[0] !== undefined) {
                for (const agreement of aggregationResult.results[0].groups) {
                    let statusAggregation: IAggregationByStatus = { byStatus: {}, totalCount: agreement.objCount };
                    if (agreement?.aggregations[0] !== undefined) {
                        statusAggregation = getStatusAggregation(agreement.aggregations[0]);
                    }
                    _state.aggregationByStatus[agreement.keyAsString] = Object.assign({}, _state.aggregationByStatus[agreement.keyAsString], statusAggregation);
                }
            }
        }
    }
};
